import React from 'react';
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetDescription } from 'src/shared/components/ui/sheet';
import ProjectStatsPanel from 'src/app/admin/components/project-stats-panel/ProjectStatsPanel';

type ProjectStatsSheetProps = {
    open: boolean;
    onOpenChange: (open: boolean) => void;
    projectId: string;
    projectName: string;
};

const ProjectStatsSheet = ({ open, onOpenChange, projectId, projectName }: ProjectStatsSheetProps) => (
    <Sheet open={open} onOpenChange={onOpenChange}>
        <SheetContent>
            <SheetHeader>
                <SheetTitle>Project stats</SheetTitle>
                <SheetDescription>What {projectName} owns today.</SheetDescription>
            </SheetHeader>

            <div className='mt-6'>
                {/* Aggregates are only worth computing once the drawer is actually open. */}
                <ProjectStatsPanel projectId={projectId} skip={!open} />
            </div>
        </SheetContent>
    </Sheet>
);

export default ProjectStatsSheet;
